import { Component, h, Host, Prop } from '@stencil/core';

import { ClassNames } from '../../utils/interfaces';

@Component({
  tag: 'patternlib-avatar',
  styleUrl: 'patternlib-avatar.scss',
  shadow: true,
})
export class PatternlibAvatar {
  /**
   * Define initials for the avatar. If more than three characters are supplied
   * the first three  are chosen as initials.
   **/
  @Prop() initials = '';

  /**
   * Remove style changes whileHover and whileActive
   */
  @Prop() noStates?: boolean;

  /**
   * Sets the background color variant.
   */
  @Prop() variant: 'default' | 'dark' = 'default';

  /**
   * Sets small variant.
   */
  @Prop() sizeSmall?: boolean;

  /**
   * Set an logged-out icon to the avatar.
   */
  @Prop() loggedOut?: boolean = false;

  /**
   * Set the width and height of the icon in px.
   */
  @Prop() iconSize: '32px' | '24px' = '32px';

  /**
   * toggle the background color
   */
  @Prop() backgroundTransparent?: boolean = false;

  render() {
    const label = this.initials.length > 3 ? this.initials.substring(0, 3).toLocaleUpperCase() : this.initials.toLocaleUpperCase();

    const loggedOut = (
      <span>
        <patternlib-icon icon-name="user" size={this.iconSize} />
      </span>
    );

    const avatarClass: ClassNames = {
      'avatar-wrapper': true,
      'avatar': true,
      'avatar-label': true,
      'no-states': this.noStates,
      'size-small': this.sizeSmall,
      'logged-out': this.loggedOut,
      'background-transparent': this.backgroundTransparent,
    };

    return (
      <Host>
        <div class={avatarClass}>{this.loggedOut ? loggedOut : <span>{label}</span>}</div>
      </Host>
    );
  }
}
